import React, {useState} from 'react';

import {Badge, Button, Image, Spin} from "antd";
import RandomImage from "@/lib/helper/randomImage";
import CopyMe from "@/lib/helper/copyMe";
import GenderComponent from "@/components/gender/GenderComponent";
import {formatDate} from "@/lib/helper/date";
import {useApiReadTeacherProfile, useApiUpdateTeacherProfile} from "@/api/userAcademy";
import ChangeProfileModalSection from "@/pages/teacher/profile/_section/changeProfileModal";
import FilePreview from "@/components/file-preview/file-preview";
import {maritalEnum} from "@/lib/helper/enumType";
import ChangeLocationModal from "@/pages/teacher/profile/_section/changeLocationModal";
import RenderIf from "@/components/render-if";
import ChangeEducationModal from "@/pages/teacher/profile/_section/changeEducationModal";
import ChangeMobileModal from "@/pages/teacher/profile/_section/changeMobileModal";
import ChangeDocumentModal from "@/pages/teacher/profile/_section/changeDocumentModal";
import UploadCMP from "@/components/upload";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import toFaNumber from "@/lib/utils/number";
import {URLS} from "@/lib/urls";
import TeacherLayout from "@/components/layout/teacher/teacherLayout";

function TeacherProfilePage() {

    const [modalIdentify, setModalIdentify] = useState(false)
    const [modalLocation, setModalLocation] = useState(false)
    const [modalEducation, setModalEducation] = useState(false)
    const [modalDocuments, setModalDocuments] = useState(false)
    const [modalMobile, setModalMobile] = useState(false)

    const {data: user, isPending: isPending, isSuccess, refetch, isRefetching} = useApiReadTeacherProfile()
    const {mutate: updateProfile} = useApiUpdateTeacherProfile();


    function updateProfileDoc(key, file) {
        let update = {}
        update[key] = file?.file?.response?.data?.id;

        updateProfile(update, {
            onSuccess: (res) => {
                refetch()
                ApiHandleSuccessMessage(res);

            },
            onError: (errors) => {
                ApiHandleErrorMessage(errors);

            },
        });
    }

    return (
        <TeacherLayout pageTitle={'نمایه شما'} backTo={URLS.teacher.dashboard}>
            {isPending && (<Spin spinning={isPending}/>)}

            {isSuccess && <div className={`flex flex-col gap-3`}>
                <ChangeProfileModalSection openModal={modalIdentify}
                                           onClose={() => setModalIdentify(false)}
                                           onSubmit={() => {
                                               setModalIdentify(false);
                                               refetch()
                                           }}
                                           user={user?.data?.data}
                />

                <ChangeLocationModal openModal={modalLocation}
                                     onClose={() => setModalLocation(false)}
                                     onSubmit={() => {
                                         setModalLocation(false);
                                         refetch()
                                     }}
                                     user={user?.data?.data}
                />
                <ChangeEducationModal openModal={modalEducation}
                                      onClose={() => setModalEducation(false)}
                                      onSubmit={() => {
                                          setModalEducation(false);
                                          refetch()
                                      }}
                                      user={user?.data?.data}
                />
                <ChangeMobileModal openModal={modalMobile}
                                   onClose={() => setModalMobile(false)}
                                   onSubmit={() => {
                                       setModalMobile(false);
                                       refetch()
                                   }}
                                   user={user?.data?.data}
                />

                <ChangeDocumentModal openModal={modalDocuments}
                                     onClose={() => setModalDocuments(false)}
                                     onSubmit={() => {
                                         setModalDocuments(false);
                                         refetch()
                                     }}
                                     user={user?.data?.data}
                />
                <Badge.Ribbon

                    size={'small'}
                    text={
                        <>
                            <span className={''}>شماره پرونده</span>
                            <CopyMe data={user?.data?.data?.code}>{toFaNumber(user?.data?.data?.code)}</CopyMe>
                        </>
                    }>

                    <div className={` h-36 rounded-lg overflow-hidden shadow relative`}>
                        <div className={`w-full h-24 relative `} style={{
                            backgroundImage: `url(${RandomImage(user?.data?.data?.id)})`,
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat'
                        }}>
                            <div
                                className={` h-20 w-20 md:h-28 md:w-28  absolute bottom-2 md:-bottom-10 border dark:border-gray-600 rounded-full right-0 left-0 m-auto md:m-0 md:right-5 overflow-hidden p-1 flex justify-center items-center`}>
                                <UploadCMP model={'avatar'} afterUploadFn={(f) => updateProfileDoc('avatar', f)}
                                           hideUploadText={true}>
                                    <Image preview={false} src={user?.data?.data?.avatar ?? `/images/profile.jpg`}
                                           className={''}
                                           alt="Image preview"/>

                                </UploadCMP>

                            </div>

                        </div>
                        <div className={`hidden lg:flex  absolute right-36 bottom-3 justify-center items-center gap-1`}>
                            <GenderComponent selfMode={true} text={user?.data?.data?.gender}/> {' '}
                            <span
                                className={`text-lg font-semibold `}>{(user?.data?.data?.firstname ?? '-') + ' ' + (user?.data?.data?.lastname ?? '-')}</span>
                            <Spin spinning={isRefetching} size={'small'}/>
                        </div>

                        <div className={`absolute bottom-2  left-0 m-auto md:m-0 left-2 `}>
                            <div className={`flex items-center flex-wrap gap-1`}>
                                <div className={`lg:hidden`}>
                                    <GenderComponent selfMode={true} text={user?.data?.data?.gender}/> {' '}
                                    <span
                                        className={`text-lg font-semibold `}>{(user?.data?.data?.firstname ?? '-') + ' ' + (user?.data?.data?.lastname ?? '-')}</span>

                                </div>

                            </div>
                        </div>
                    </div>
                </Badge.Ribbon>
                <div className={`w-full  rounded shadow-sm p-4 flex flex-col gap-3 relative`}>
                    <div className="flex items-center justify-between gap-2 flex-wrap">
                        <div>
                            <i className={`icon-user text-green-6`}></i>
                            <span className={`text-lg mx-2`}>اطلاعات هویتی</span>

                        </div>

                        <Button onClick={() => {
                            setModalIdentify(true)
                        }}>
                            ویرایش
                        </Button>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

                        <DetailProfileWidget label={"نام"} value={user?.data?.data?.firstname}/>
                        <DetailProfileWidget label={"نام‌خانوادگی"} value={user?.data?.data?.lastname}/>
                        <DetailProfileWidget label={"نام پدر"} value={user?.data?.data?.father}/>
                        <DetailProfileWidget label={"تاریخ تولد"}
                                             value={user?.data?.data?.birthdate ? formatDate(user?.data?.data?.birthdate) : null}/>
                        <DetailProfileWidget label={"وضعیت تاهل"} value={maritalEnum(user?.data?.data?.marital)}/>
                        <DetailProfileWidget label={`ملیت`} value={user?.data?.data?.nationality_detail?.fa_name}/>

                        <RenderIf condition={user?.data?.data?.nationality === 'IR'}>
                            <DetailProfileWidget label={`کدملی`} value={user?.data?.data?.nationalcode}/>
                            <DetailProfileWidget label={'محل صدور شناسنامه'} value={user?.data?.data?.shfrom}/>
                        </RenderIf>

                        <DetailProfileWidget label={`شماره گذرنامه`} value={user?.data?.data?.pasportcode}/>
                        <DetailProfileWidget label={`تاریخ انقضای گذرنامه`}
                                             value={formatDate(user?.data?.data?.pasportdate)}/>

                    </div>
                </div>


                <div className={`w-full  rounded shadow-sm p-4 flex flex-col gap-3 relative`}>
                    <div className="flex items-center justify-between gap-2 flex-wrap">
                        <div>
                            <i className={`icon-location-dot text-blue-600`}></i>
                            <span className={`text-lg mx-2`}>آدرس و موقعیت</span>
                        </div>

                        <Button onClick={() => {
                            setModalLocation(true)
                        }}>
                            ویرایش
                        </Button>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

                        <DetailProfileWidget label={'کشور'} value={user?.data?.data?.country_detail?.fa_name}/>
                        <DetailProfileWidget label={'استان'} value={user?.data?.data?.province_detail?.fa_name}/>
                        <DetailProfileWidget label={'شهر'} value={user?.data?.data?.city_detail?.localname}/>
                        <DetailProfileWidget label={'کدپستی'} value={user?.data?.data?.zipcode}/>

                        <DetailProfileWidget label={`آدرس`} value={user?.data?.data?.address}/>

                    </div>
                </div>


                <div className={`w-full  rounded shadow-sm p-4 flex flex-col gap-3 relative`}>
                    <div className="flex items-center justify-between gap-2 flex-wrap">
                        <div>
                            <i className={`icon-book text-blue-600`}></i>
                            <span className={`text-lg mx-2`}>تحصیلات</span>
                        </div>

                        <Button onClick={() => {
                            setModalEducation(true)
                        }}>
                            ویرایش
                        </Button>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

                        <DetailProfileWidget label={'تحصیلات'} value={user?.data?.data?.education}/>
                        <DetailProfileWidget label={'رشته تحصیلی'} value={user?.data?.data?.educationcourse}/>
                        <DetailProfileWidget label={'تحصیلات ثانوی'} value={user?.data?.data?.education2}/>


                    </div>
                </div>

                <div className={`w-full  rounded shadow-sm p-4 flex flex-col gap-3 relative`}>
                    <div className="flex items-center justify-between gap-2 flex-wrap">
                        <div>
                            <i className={`icon-mobile text-blue-600`}></i>
                            <span className={`text-lg mx-2`}>پل‌های ارتباطی</span>
                        </div>

                        <Button onClick={() => {
                            setModalMobile(true)
                        }}>
                            ویرایش
                        </Button>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

                        <DetailProfileWidget label={'موبایل'} value={user?.data?.data?.mobile}/>
                        <DetailProfileWidget label={'موبایل دوم'} value={user?.data?.data?.mobile2}/>
                        <DetailProfileWidget label={'تلفن ثابت'} value={user?.data?.data?.phone}/>
                        <DetailProfileWidget label={'رایانامه'} value={user?.data?.data?.email}/>
                        <DetailProfileWidget label={'موبایل پدر'} value={user?.data?.data?.fathermobile}
                                             showIfValue={true}/>
                        <DetailProfileWidget label={'موبایل مادر'} value={user?.data?.data?.mothermobile}
                                             showIfValue={true}/>


                    </div>
                </div>


                <div className={`w-full  rounded shadow-sm p-4 flex flex-col gap-3 relative`}>
                    <div className="flex items-center justify-between gap-2 flex-wrap">
                        <div>
                            <i className={`icon-image text-blue-600`}></i>
                            <span className={`text-lg mx-2`}>اسناد الکترونیکی</span>
                        </div>

                        <Button onClick={() => {
                            setModalDocuments(true)
                        }}>
                            ویرایش
                        </Button>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">

                        <DetailProfileWidget label={'تصویر کارت شناسایی'}
                                             value={<FilePreview fileUrl={user?.data?.data?.file1}/>}/>
                        <DetailProfileWidget label={'تصویر کارت ملی'}
                                             value={<FilePreview fileUrl={user?.data?.data?.file2}/>}/>
                        <DetailProfileWidget label={'تصویر مدرک تحصیلی'}
                                             value={<FilePreview fileUrl={user?.data?.data?.file3}/>}/>


                    </div>
                </div>


            </div>}

        </TeacherLayout>
    );
}

export default TeacherProfilePage;


export const DetailProfileWidget = ({label, value, showIfValue = false}) => {

    if (showIfValue && !value) {
        return null
    }

    return (<div className="flex items-center gap-2 flex-wrap">
        <span className={` `}> {label} :</span>
        <span className={`font-semibold`}> {value}</span>
    </div>)
}
